function loadSVGIcons () {

    Handlebars.registerPartial("icoContentAppArticle", $("#icoContentAppArticle").html());
    Handlebars.registerPartial("icoContentAppAudio", $("#icoContentAppAudio").html());
    Handlebars.registerPartial("icoContentAppDocument", $("#icoContentAppDocument").html());
    Handlebars.registerPartial("icoContentAppExternal", $("#icoContentAppExternal").html());
    Handlebars.registerPartial("icoContentAppGallery", $("#icoContentAppGallery").html());
    Handlebars.registerPartial("icoContentAppGame", $("#icoContentAppGame").html());
    Handlebars.registerPartial("icoContentAppTest", $("#icoContentAppTest").html());
    Handlebars.registerPartial("icoContentAppPool", $("#icoContentAppPool").html());
    Handlebars.registerPartial("icoContentAppPdf", $("#icoContentAppPdf").html());
    Handlebars.registerPartial("icoContentAppZip", $("#icoContentAppZip").html());
    Handlebars.registerPartial("icoContentAppVideo", $("#icoContentAppVideo").html());
    Handlebars.registerPartial("icoContentAppHtml5", $("#icoContentAppHtml5").html());
    Handlebars.registerPartial("icoContentAppImage", $("#icoContentAppImage").html());
    Handlebars.registerPartial("icoContentAppInternalLink", $("#icoContentAppInternalLink").html());
    Handlebars.registerPartial("icoContentAppPath", $("#icoContentAppPath").html());
    Handlebars.registerPartial("icoCreateArticle", $("#icoCreateArticle").html());
    Handlebars.registerPartial("icoCreateCamera", $("#icoCreateCamera").html());
    Handlebars.registerPartial("icoCreateClose", $("#icoCreateClose").html());
    Handlebars.registerPartial("icoCreateDocument", $("#icoCreateDocument").html());
    Handlebars.registerPartial("icoCreateDrafts", $("#icoCreateDrafts").html());
    Handlebars.registerPartial("icoCreateExternal", $("#icoCreateExternal").html());
    Handlebars.registerPartial("icoCreateImage", $("#icoCreateImage").html());
    Handlebars.registerPartial("icoCreateOpen", $("#icoCreateOpen").html());
    Handlebars.registerPartial("icoEditorAddExternal", $("#icoEditorAddExternal").html());
    Handlebars.registerPartial("icoEditorAddImage", $("#icoEditorAddImage").html());
    Handlebars.registerPartial("icoEditorBulletsLi", $("#icoEditorBulletsLi").html());
    Handlebars.registerPartial("icoEditorBulletsNone", $("#icoEditorBulletsNone").html());
    Handlebars.registerPartial("icoEditorBulletsUl", $("#icoEditorBulletsUl").html());
    Handlebars.registerPartial("icoEditorLine", $("#icoEditorLine").html());
    Handlebars.registerPartial("icoEditorQuotestyleNone", $("#icoEditorQuotestyleNone").html());
    Handlebars.registerPartial("icoEditorQuotestyleQ1", $("#icoEditorQuotestyleQ1").html());
    Handlebars.registerPartial("icoEditorQuotestyleQ2", $("#icoEditorQuotestyleQ2").html());
    Handlebars.registerPartial("icoEditorTextstyleH1", $("#icoEditorTextstyleH1").html());
    Handlebars.registerPartial("icoEditorTextstyleH2", $("#icoEditorTextstyleH2").html());
    Handlebars.registerPartial("icoEditorTextstyleNone", $("#icoEditorTextstyleNone").html());
    Handlebars.registerPartial("icoEditorUndo", $("#icoEditorUndo").html());
    Handlebars.registerPartial("icoContentAppGameBulb", $("#icoContentAppGameBulb").html());
    Handlebars.registerPartial("icoContentAppGameClick", $("#icoContentAppGameClick").html());
    Handlebars.registerPartial("icoContentAppGameDown", $("#icoContentAppGameDown").html());
    Handlebars.registerPartial("icoContentAppGameUp", $("#icoContentAppGameUp").html());
    Handlebars.registerPartial("icoContentAppGameTrophy", $("#icoContentAppGameTrophy").html());
    Handlebars.registerPartial("icoContentAppGameIncredible", $("#icoContentAppGameIncredible").html());
    Handlebars.registerPartial("icoContentAppGameGood", $("#icoContentAppGameGood").html());
    Handlebars.registerPartial("icoContentAppGameUps", $("#icoContentAppGameUps").html());
    Handlebars.registerPartial("icoContentAppGameLink", $("#icoContentAppGameLink").html());
    Handlebars.registerPartial("icoContentAppPathAssessmentAdvanced", $("#icoContentAppPathAssessmentAdvanced").html());
    Handlebars.registerPartial("icoContentAppPathAssessmentMedium", $("#icoContentAppPathAssessmentMedium").html());
    Handlebars.registerPartial("icoContentAppPathAssessmentLow", $("#icoContentAppPathAssessmentLow").html());
    Handlebars.registerPartial("icoContentAppMenu", $("#icoContentAppMenu").html());
    Handlebars.registerPartial("icoContentAppBloqued", $("#icoContentAppBloqued").html());
    Handlebars.registerPartial("icoContentAppCalendar", $("#icoContentAppCalendar").html());
    Handlebars.registerPartial("icoNew", $("#icoNew").html());
    Handlebars.registerPartial("icoFavourite", $("#icoFavourite").html());
    Handlebars.registerPartial("icoFavouriteFilled", $("#icoFavouriteFilled").html());
    Handlebars.registerPartial("icoView", $("#icoView").html());
    Handlebars.registerPartial("icoContentCompletedBlack", $("#icoContentCompletedBlack").html());
    Handlebars.registerPartial("icoContentNewBlack", $("#icoContentNewBlack").html());
    Handlebars.registerPartial("icoLike", $("#icoLike").html());
    Handlebars.registerPartial("icoChallenge", $("#icoChallenge").html());
    Handlebars.registerPartial("icoUserCall", $("#icoUserCall").html());
    Handlebars.registerPartial("icoUserChat", $("#icoUserChat").html());
    Handlebars.registerPartial("icoUserMail", $("#icoUserMail").html());
    Handlebars.registerPartial("icoComment", $("#icoComment").html());
    Handlebars.registerPartial("icoContentAppGameStill", $("#icoContentAppGameStill").html());
    Handlebars.registerPartial("icoForward", $("#icoForward").html());
    Handlebars.registerPartial("icoLikeFilled", $("#icoLikeFilled").html());
    Handlebars.registerPartial("icoPoints", $("#icoPoints").html());
    Handlebars.registerPartial("icoShare", $("#icoShare").html());
    Handlebars.registerPartial("icoRating", $("#icoRating").html());
    Handlebars.registerPartial("icoNotification", $("#icoNotification").html());
    Handlebars.registerPartial("icoNotificationAlert", $("#icoNotificationAlert").html());
    Handlebars.registerPartial("icoContentNotAttempted", $("#icoContentNotAttempted").html());
    Handlebars.registerPartial("icoContentInProcess", $("#icoContentInProcess").html());
    Handlebars.registerPartial("icoContentCompleted", $("#icoContentCompleted").html());
    Handlebars.registerPartial("icoPlaceholderActivity", $("#icoPlaceholderActivity").html());
    Handlebars.registerPartial("icoUserFollow", $("#icoUserFollow").html());
    Handlebars.registerPartial("icoTaskApproved", $("#icoTaskApproved").html());
    Handlebars.registerPartial("icoTaskRejected", $("#icoTaskRejected").html());
    Handlebars.registerPartial("icoTaskOverdue", $("#icoTaskOverdue").html());
    Handlebars.registerPartial("icoAtMention", $("#icoAtMention").html());
    Handlebars.registerPartial("icoNewPublication", $("#icoNewPublication").html());
    Handlebars.registerPartial("icoConfetti", $("#icoConfetti").html());
    Handlebars.registerPartial("icoCoins", $("#icoCoins").html());
    Handlebars.registerPartial("icoEarth", $("#icoEarth").html());
    Handlebars.registerPartial("icoMenu", $("#icoMenu").html());
    Handlebars.registerPartial("icoFolder", $("#icoFolder").html());
    Handlebars.registerPartial("icoInfoSheet", $("#icoInfoSheet").html());
    Handlebars.registerPartial("icoReload", $("#icoReload").html());
    Handlebars.registerPartial("icoUxEdit", $("#icoUxEdit").html());
    Handlebars.registerPartial("icoUxDelete", $("#icoUxDelete").html());
    Handlebars.registerPartial("icoUxSearch", $("#icoUxSearch").html());
    Handlebars.registerPartial("icoEyeCheck", $("#icoEyeCheck").html());
    Handlebars.registerPartial("icoUxOptions", $("#icoUxOptions").html());
    Handlebars.registerPartial("icoUxSpeakerphone", $("#icoUxSpeakerphone").html());

    Handlebars.registerPartial("refreshIcon", $("#refreshIcon").html());
    Handlebars.registerPartial("myDeviceIcon", $("#myDeviceIcon").html());
    Handlebars.registerPartial("clockIcon", $("#clockIcon").html());
    Handlebars.registerPartial("arrowLeftIcon", $("#arrowLeftIcon").html());
    Handlebars.registerPartial("arrowRightIcon", $("#arrowRightIcon").html());
    Handlebars.registerPartial("chevronDownIcon", $("#chevronDownIcon").html());
    Handlebars.registerPartial("chevronRightIcon", $("#chevronRightIcon").html());
    Handlebars.registerPartial("chevronLeftIcon", $("#chevronLeftIcon").html());
    Handlebars.registerPartial("arrowUpCircleIcon", $("#arrowUpCircleIcon").html());

}